import { DateTime } from 'luxon';
import { AppConfig } from '../config/AppConfig';
import { diContainer } from './container';

const PING = 'ping';
const PONG = 'pong';

const PING_INTERVAL = 9.75 * 60 * 1000; // minutes * seconds * millis
const RECONECT_TIMEOUT = 1 * 1000; // seconds * millis
const PING_PONG_TIMEOUT = 5 * 1000; // seconds * millis

export const NORMAL_CLOSURE = 1000; // Normal closure code

const MAXIMUM_RECONNECT_COUTNER = 10;

class WebSocketService {
    private socket?: WebSocket;
    private lastPing?: DateTime;
    private interval?: NodeJS.Timer;
    private connected: boolean;
    private reconnectCounter: number;

    public constructor() {
        this.connected = false;
        this.reconnectCounter = 0;
    }

    public connect(userSub: string, accessToken: string, onMessage: (event: MessageEvent) => void): void {
        if (this.isConected()) return;

        this.socket = new WebSocket(this.getConnectionUrl(userSub, accessToken));

        this.socket.onopen = () => {
            this.connected = true;
            this.reconnectCounter = 0;
            this.interval = setInterval(this.ping.bind(this), PING_INTERVAL);
        };

        this.socket.onmessage = (event: MessageEvent) => {
            const data = JSON.parse(event.data);
            if (data.body !== PONG) {
                onMessage(event);
                return;
            }
            if (this.pingPongDiff() < PING_PONG_TIMEOUT) return;
            this.disconnect();
        };

        this.socket.onclose = (event: CloseEvent) => {
            this.connected = false;

            if (this.interval) clearInterval(this.interval);

            if (event.code === NORMAL_CLOSURE) return;

            if (this.reconnectCounter > MAXIMUM_RECONNECT_COUTNER) return;

            this.reconnectCounter += 1;
            setTimeout(() => {
                this.connect(userSub, accessToken, onMessage);
            }, RECONECT_TIMEOUT);
        };
    }

    private getConnectionUrl(userSub: string, accessToken: string): string {
        return `${AppConfig.webSocketURL}?userSub=${userSub}&token=${accessToken}`;
    }

    private isConected(): boolean {
        return this.socket?.readyState === WebSocket.OPEN && this.connected;
    }

    public disconnect(code?: number): void {
        if (this.socket && this.isConected()) this.socket.close(code);
    }

    private ping(): void {
        if (!this.socket) return;
        this.socket.send(JSON.stringify({ action: PING }));
        this.lastPing = DateTime.now();
    }

    private pingPongDiff(): number {
        if (!this.lastPing) return PING_PONG_TIMEOUT + 1;
        return DateTime.now().diff(this.lastPing).milliseconds;
    }
}

export default WebSocketService;

diContainer.bindAsConstant(WebSocketService, new WebSocketService());
